import React from 'react';
import ReactDOM from 'react-dom';
import Iconify from '../Iconify';
import useRealNode from '../../hooks/useRealNode';
import { ModalPanel, Bar, CloseButton, Content } from './shared/components/modals/modal-styled';
import { PaymentsMethods } from './payments-methods';

export const Modal = props => {
  const node = useRealNode('modal-node-portal');

  const handleClose = () => {
    if (props.dispatch) {
      props.updatePanelSate(props.dispatch);
    } else {
      props.updatePanelSate();
    }
  };

  const stopPropagation = event => {
    event.stopPropagation();
  };

  if (!props.showAbonarSaldo) return null;

  return ReactDOM.createPortal(
    <ModalPanel tabIndex="1" onMouseDown={stopPropagation}>
      <Content style={{ maxWidth: 700, minHeight: 200 }}>
        <Bar>
          <CloseButton onClick={handleClose}>
            <Iconify icon="ic:baseline-close" />
          </CloseButton>
        </Bar>
        <PaymentsMethods {...props} />
      </Content>
    </ModalPanel>,
    node
  );
};
